import type { SettingsCategoryId } from '../components/settings/settings-categories';
import { useDialog } from './DialogProvider';

/** Which view the settings dialog should land on when it opens. */
export type SettingsModalView = 'settings' | 'manageAccount' | 'accountEdit';
export type SettingsModalSection = 'name' | 'username' | 'email' | 'password';

export interface SettingsModalOptions {
  view?: SettingsModalView;
  /** Only meaningful with view 'accountEdit'. */
  section?: SettingsModalSection;
  /**
   * Settings category to land on (view 'settings'). Lets a surface outside
   * the dialog open, say, Data management in place instead of navigating to
   * its `/settings/*` page.
   */
  category?: SettingsCategoryId;
}

export function useSettingsModal() {
  const { open } = useDialog();

  return {
    open: (options?: SettingsModalOptions) =>
      open(
        'settings',
        options?.view || options?.category ? { ...options } : undefined,
      ),
  };
}
